"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = require("../theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HTMLInput = (0, _theme.styled)('input')(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      hasError = _ref.hasError,
      height = _ref.height,
      required = _ref.required,
      success = _ref.success,
      width = _ref.width,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var inputTheme = theme.components.input[variant];
  var errorState = !disabled && hasError && inputTheme ? inputTheme.error : {};
  var requiredState = !disabled && required && inputTheme ? inputTheme.required : {};
  var successState = !disabled && !hasError && inputTheme && success ? inputTheme.success : {};
  return _objectSpread({
    boxSizing: 'border-box',
    margin: 0
  }, inputTheme, {
    height: height,
    width: width
  }, errorState, {}, requiredState, {}, successState);
});
var _default = HTMLInput;
exports.default = _default;